import React from 'react';
import logo from '../../svg/logo.svg';
import './LandingPage.css';

/**
 * This is the landing page when not logged in.
 *
 * @returns LandingPage
 */
export function LandingPage() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit
          {' '}
          <code>src/App.tsx</code>
          {' '}
          and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          A little testy
        </a>
      </header>
    </div>
  );
}
